<app-dynamic-form title="Dependant" [input]="data!" (result)="doHandleResult($event)"></app-dynamic-form>
